












































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import IPlay from '@/components/icons/IPlay.vue'
import {baseUrl} from "@/service/ApiClient";

const dialog = namespace('dialog')
const forms = namespace('forms')
const newshards = namespace('newshards')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    'i-play': IPlay,
  },
  name: "NoteEditForm"
})
export default class NoteEditForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @newshards.Action('editMediaAttachmentFromServerCompany') protected editMediaAttachmentFromServerCompany:any
  @newshards.Action('editMediaAttachmentFromServerPersonal') protected editMediaAttachmentFromServerPersonal:any

  wavesurfers:any = {}
  headers: any[] = [
    {text: 'Дата', sortable: true, value: 'date'},
    {text: 'Пользователь', sortable: true, value: 'user'},
    {text: 'Действие', sortable: true, value: 'action'},
    {text: 'Поле', sortable: true, value: 'field'},
    {text: 'Платформа', sortable: true, value: 'platform'},
    {text: 'Изменения', sortable: false, value: 'change'}
  ]
  baseURL:any =baseUrl()
  workspace:string = ''

  @Watch('fullDialogShow')
  getFullDialogShow(NewVal: any) {
    if(this.fullDialogShow) {
      this.workspace = this.$route.params.code
    }
    /*if(NewVal && this.options.note.type == 'voice') {
      let elem = WaveSurfer.create({
        container: "#wave",
        height: 40,
        waveColor: "#8EC6E7",
        progressColor: "#2D9CDB",
        cursorWidth: 0,
        id: '123'
      });
      elem.load('http://localhost:8080/img/audio.mp3');
      this.wavesurfers = elem;
    }*/
  }

  created(){
    this.getFullDialogShow(true)
  }

  save() {
    //editMediaAttachmentFromServerPersonal
    if(this.options.note.type == 'note' || this.options.note.text.length) {
      if(this.workspace === 'personal') {
        this.editMediaAttachmentFromServerPersonal({
            params: {
              id: this.options.note.id,
            },
            body: {
              text: this.options.note.text
            }
        })
      } else {
        this.editMediaAttachmentFromServerCompany({
            params: {
              companyCode: this.$route.params.code,
              id: this.options.note.id,
            },
            body: {
              text: this.options.note.text
            }
        })
      }
      this.SetFullDialogShow(false)
    } else {
      this.SetFullDialogShow(false)
    }
  }

}
